import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { NotificationsController } from './notifications.controller';
import { NotificationsService } from './notifications.service';
import { NotificationAdapter } from './dto/notifications.adapter';
import { Notifications } from './notifications.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([Notifications]),
  ],
  controllers: [NotificationsController],
  providers: [NotificationsService, NotificationAdapter, ApplicationExceptionHandler],
  exports: [NotificationsService]
})
export class NotificationsModule {}
